import { ModuleWithProviders, NgModule } from '@angular/core';
import { FeatureFlagDirective } from './feature-flag.directive';
import { FeatureFlags } from './feature-flag.injection-token';
import { provideFeatureFlag } from './provide-feature-flag';

@NgModule({
  declarations: [FeatureFlagDirective],
  exports: [FeatureFlagDirective],
})
export class FeatureFlagModule {
  static forRoot(featureFlags: FeatureFlags): ModuleWithProviders<FeatureFlagModule> {
    return {
      ngModule: FeatureFlagModule,
      providers: [provideFeatureFlag(featureFlags)],
    };
  }
}
